/*
Menu.js owns the menu buttons
*/
import Phaser, {
    Display
} from 'phaser'

import gsap from "gsap";
import Overlay from './locations/Overlay';

let gameScale;
let navBG;
let navSkipBG
let skip;
let home;
let sound;
let soundOff;
let matchBG;
let match;
let language;
let utils;
let sounds;
let buttonsArray;
let world;


export default class Menu extends Phaser.Scene {
    constructor() {
        super('menu')
    }

    preload() {
        gameScale = this.registry.values.scaleIt;

    }
    create() {
        utils = this.scene.get('utils');
        sounds = this.scene.get('sounds');
        world = this.scene.get('world');
        //add opening image of guide 


        navSkipBG = utils.addImage(this, {
            x: 563,
            y: -3,
            id: 'navBGSkip'
        });
        //this.add.image(563 * gameScale, -3 * gameScale, 'navBGSkip').setOrigin(0, 0)
        skip = utils.addImage(this, {
            x: 637,
            y: 35,
            id: 'skipEnglish',

            str: 'skip'
        });

        sound = utils.addImage(this, {
            x: 705,
            y: 34,
            id: 'soundEnglish',
            str: 'sound'
        })

        soundOff = utils.addImage(this, {
            x: 705,
            y: 34,
            id: 'soundOffEnglish',
            str: 'soundOff'

        });

        language = utils.addImage(this, {
            x: 770,
            y: 38,
            id: 'languageEnglish',
            str: 'language'
        })


        buttonsArray = [skip, sound, soundOff, language];


        for (let index = 0; index < buttonsArray.length; index++) {
            utils.globalButton(buttonsArray[index]);
        }

        soundOff.setVisible(false);
        let s = this.scene.get('intro');
        skip.on('pointerdown', s.skipIntro, s);
        language.on('pointerdown', this.toggleLanguage, this);

        s = this.scene.get('sounds');
        sound.on('pointerdown', s.muteSound, s);
        soundOff.on('pointerdown', s.muteSound, s);

        // this.registry.events.on('changedata', this.handleLanguage, this);
    }

    handleLanguage() {
        for (let index = 0; index < buttonsArray.length; index++) {
            utils.overOutLanguageButton(buttonsArray[index], 'out');
        }
    }



    showMatch() {
        matchBG = this.add.image(485 * gameScale, -3 * gameScale, 'matchBG').setOrigin(0, 0);
        matchBG.setDepth(-10);
        match = utils.addImage(this, {
            x: 537,
            y: 31,
            id: 'matchEnglish',
            str: 'match'
        });
        utils.globalButton(match);

        match.setData('scale', 1);

        let navigate = this.scene.get('navigate');

        match.on('pointerdown', () => {
                // world.stopFollow();
                navigate.handleLocation({
                    location: 'matching',
                    img: match
                });
            }

        );

    }

    showHideMatch(isVis = true) {

        matchBG.setVisible(isVis);
        match.setVisible(isVis);


    }

    showSound(val) {
        sound.setVisible(!val);
        soundOff.setVisible(val);

        utils.overOutLanguageButton(sound, 'over');
        utils.overOutLanguageButton(soundOff, 'over');

    }

    //Event Handler for language button. Rest of scenes listen for change in data
    toggleLanguage() {
        sounds.playClick();
        this.registry.set('isEnglish', !this.registry.get('isEnglish'));
        //Only instant change for now, perhaps use registry for global instant language swap
        utils.handleLanguage();
    }

    //A button has been clicked
    clickButton() {
        //to avoid accidental clicks while dragging around the world compare the down x to the up x 
        //Leave wiggle room for fingers
        let pointX = Math.ceil(_this.input.activePointer.x);
        let diff = Math.abs(pointX - clickX);
        if (diff > 5) return;
        //the start down and end up positions matched, so off we go!
        //Roll off the location
        _this.outLocation(this);
        //Play sound feedback
        sounds.playClick();
        _this.handleLocation({
            location: this.getData('location'),
            img: this
        })

    }

    getBGPos() {

        return (navSkipBG);

    }

    //Called once to transition from intro to home
    showHome() {
        //world.stopFollow();

        navBG = utils.addImage(this, {
            x: 563,
            y: -3,
            id: 'navBGHome'
        });

        navBG.setDepth(-9);
        gsap.from(navBG, {
            duration: 0.25,
            x: '+=200',
            ease: 'sine.Out'
        });
        gsap.to(navSkipBG, {
            duration: 0.5,
            x: '+=200',
            delay: 0.25,
            ease: 'sine.In',
            alpha: 0
        });

        //ENGLISH OR MAORI
        home = this.add.image(632 * gameScale, 31 * gameScale, 'homeEnglish').setOrigin(0.5, 0.5).setData({
            str: 'home'
        });
        utils.globalButton(home);
        let navigate = this.scene.get('navigate');
        home.on('pointerdown', navigate.goHome, this);
        this.showMatch();


        utils.removeButton(skip);
        buttonsArray.push(home);
        //this.input.setTopOnly(true);
        navBG.on('pointerup', world.stopFollow);
        matchBG.on('pointerup', world.stopFollow);

    }

}